import axios from 'axios';
import { NOTIFY_API_BASE_URL, PLATFORM_CODE } from '../../../constants';
import { localStorageUtil } from '../../utils/localStorageUtil';

export const gqNotifyApiClient = axios.create({
    baseURL: NOTIFY_API_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
    },
});

gqNotifyApiClient.interceptors.request.use(
    config => {
        const token = localStorageUtil.getItem('gqnotify_accesstoken');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

gqNotifyApiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {
        const originalRequest = error.config;

        if (typeof error.response === 'undefined') {

            return Promise.reject(error);
        }

        if (
            error.response.status === 403 &&
            originalRequest.url === '/v1/auth/login/regenerate-token'
        ) {
            window.location.href = '/';
            return Promise.reject(error);
        }

        if (error.response.status === 403) {
            const refreshToken = localStorageUtil.getItem('gqnotify_refreshtoken');

            if (refreshToken !== "") {
                const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));
                const now = Math.ceil(Date.now() / 1000);

                if (tokenParts.exp > now) {
                    return gqNotifyApiClient
                        .post(`/v1/auth/regenerate-token`, { "refresh_token": refreshToken })
                        .then((response) => {
                            localStorageUtil.setItem('gqnotify_accesstoken', response.data.data.access_token);
                            localStorageUtil.setItem('gqnotify_refreshtoken', response.data.data.refresh_token);
                            gqNotifyApiClient.defaults.headers['Authorization'] =
                                'Bearer ' + response.data.data.access_token;
                            originalRequest.headers['Authorization'] =
                                'Bearer ' + response.data.data.access_token;
                            return gqNotifyApiClient(originalRequest);
                        })
                        .catch((err) => {
                            // window.location.href = '/';
                            localStorageUtil.clear();
                        });
                } else {
                    gqNotifyApiClient({
                        method: 'POST',
                        url: `/v1/auth/authorize`,
                        data: {
                            "platform_code": PLATFORM_CODE
                        }
                    }).then(res => {
                        localStorageUtil.setItem("gqnotify_accesstoken", res.data.data.access_token);
                        localStorageUtil.setItem("gqnotify_refreshtoken", res.data.data.refresh_token);
                    });
                }
            } else {
                window.location.href = '/';
                localStorageUtil.clear();
            }
        }
        return Promise.reject(error);
    }

);